import {FC, useMemo} from 'react'
import PaymentProcessButton from '../payment/PaymentProcessButton'
import {OrderModal, OrderModalButton} from 'app/features/orders/componentsv1'
import {simpleCurrency} from 'app/format/currency'
import filter from 'lodash/filter'

type Props = {
  onClose: () => void
  discounts: any[]
}

const PromoRemoveWithPayment: FC<Props> = ({onClose, discounts}) => {
  const wineClubDiscounts = useMemo(() => {
    const discount = filter(discounts, ({isWineClub}) => !!isWineClub)
    if (discount && discount.length > 0) {
      return discount[0].amount
    }
    return 0
  }, [discounts])

  return (
    <OrderModal
      title='Discount Process'
      onClose={onClose}
      hideFooter
      icon='percentage-discount'
      subTitle={<hr />}
    >
      <div className='fw-bolder fs-4 mb-5'>
        {wineClubDiscounts > 0
          ? `The Promo code has been removed and Applied Auto Discount of ${simpleCurrency(
              wineClubDiscounts
            )}`
          : 'The Promo code has been removed'}
        , Do you want to process payment
      </div>

      <OrderModalButton type='submit' onClose={onClose} btnCancel='No'>
        <PaymentProcessButton />
      </OrderModalButton>
    </OrderModal>
  )
}
export default PromoRemoveWithPayment
